module.exports = __webpack_public_path__ + "img/icon-handshake@3x.f30737a4.png";